module.exports = __webpack_public_path__ + "img/editprofile.88582d35.svg";